var _style, _g, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 400 2000 1100",
    width: 300,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill:#FFFF;}\r\n\t.st2{fill:url(#SVGID_1_);}\r\n\t.st3{fill:url(#SVGID_2_);}\r\n\t.st4{fill:url(#SVGID_3_);}\r\n\t.st5{fill:url(#SVGID_4_);}\r\n\t.st6{fill:url(#SVGID_5_);}\r\n\t.st7{fill:url(#SVGID_6_);}\r\n\t.st8{fill:url(#SVGID_7_);}\r\n\t.st9{fill:url(#SVGID_8_);}\r\n")), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M482.5,1035.3c-3.72,0-6.92-1.34-9.6-4.01c-2.68-2.68-4.01-5.87-4.01-9.6v-43.28c0-3.72,1.34-6.92,4.01-9.6 c2.68-2.68,5.87-4.01,9.6-4.01h43.18c3.79,0,7.02,1.34,9.69,4.01c2.68,2.68,4.01,5.87,4.01,9.6v5.48h-13.02v-2.64 c0-1.83-0.13-2.86-0.39-3.08c-0.26-0.23-1.27-0.34-3.04-0.34h-37.7c-1.83,0-2.86,0.11-3.08,0.34c-0.23,0.23-0.34,1.26-0.34,3.08 v37.6c0,1.83,0.11,2.86,0.34,3.08c0.23,0.23,1.26,0.34,3.08,0.34h37.7c1.76,0,2.77-0.11,3.04-0.34c0.26-0.23,0.39-1.26,0.39-3.08 v-10.48h-15.96v-13.02h28.98v26.34c0,3.72-1.34,6.92-4.01,9.6c-2.68,2.68-5.91,4.01-9.69,4.01H482.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M567.98,1035.3v-56.89c0-3.72,1.34-6.92,4.01-9.6c2.68-2.68,5.87-4.01,9.6-4.01h43.18 c3.78,0,7.02,1.34,9.69,4.01c2.68,2.68,4.01,5.87,4.01,9.6v56.89h-13.02v-23.7H580.9v23.7H567.98z M580.9,998.68h44.55v-17.43 c0-1.83-0.13-2.86-0.39-3.08c-0.26-0.23-1.27-0.34-3.04-0.34h-37.7c-1.83,0-2.86,0.11-3.08,0.34c-0.23,0.23-0.34,1.26-0.34,3.08 V998.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M667.37,1035.3v-70.6h12.92v57.58h57.57v13.02H667.37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M761.36,1035.3v-56.89c0-3.72,1.34-6.92,4.01-9.6c2.68-2.68,5.87-4.01,9.6-4.01h43.18 c3.78,0,7.02,1.34,9.69,4.01c2.68,2.68,4.01,5.87,4.01,9.6v56.89h-13.02v-23.7h-44.55v23.7H761.36z M774.29,998.68h44.55v-17.43 c0-1.83-0.13-2.86-0.39-3.08c-0.26-0.23-1.27-0.34-3.04-0.34h-37.7c-1.83,0-2.86,0.11-3.09,0.34c-0.23,0.23-0.34,1.26-0.34,3.08 V998.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M874.26,1035.3c-3.72,0-6.92-1.34-9.6-4.01c-2.68-2.68-4.01-5.87-4.01-9.6v-43.28c0-3.72,1.34-6.92,4.01-9.6 c2.68-2.68,5.87-4.01,9.6-4.01h56.69v13.02H877c-1.83,0-2.86,0.11-3.09,0.34c-0.23,0.23-0.34,1.26-0.34,3.08v37.6 c0,1.83,0.11,2.86,0.34,3.08c0.23,0.23,1.26,0.34,3.09,0.34h53.95v13.02H874.26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M984.02,1035.3v-57.48h-28.79V964.8h70.5v13.02h-28.69v57.48H984.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1050.31,1035.3v-70.5h12.83v70.5H1050.31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1102.89,1035.3c-3.72,0-6.92-1.34-9.6-4.01c-2.68-2.68-4.01-5.87-4.01-9.6v-43.28c0-3.72,1.34-6.92,4.01-9.6 c2.68-2.68,5.87-4.01,9.6-4.01h56.69v13.02h-53.95c-1.83,0-2.86,0.11-3.09,0.34c-0.23,0.23-0.34,1.26-0.34,3.08v37.6 c0,1.83,0.11,2.86,0.34,3.08c0.23,0.23,1.26,0.34,3.09,0.34h53.95v13.02H1102.89z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1248.59,1035.3c-3.72,0-6.92-1.34-9.6-4.01c-2.68-2.68-4.01-5.87-4.01-9.6v-43.28c0-3.72,1.34-6.92,4.01-9.6 c2.68-2.68,5.87-4.01,9.6-4.01h43.18c3.78,0,7.02,1.34,9.69,4.01c2.68,2.68,4.01,5.87,4.01,9.6v5.48h-13.02v-2.64 c0-1.83-0.13-2.86-0.39-3.08c-0.26-0.23-1.27-0.34-3.04-0.34h-37.7c-1.83,0-2.86,0.11-3.09,0.34c-0.23,0.23-0.34,1.26-0.34,3.08 v37.6c0,1.83,0.11,2.86,0.34,3.08c0.23,0.23,1.26,0.34,3.09,0.34h37.7c1.76,0,2.77-0.11,3.04-0.34c0.26-0.23,0.39-1.26,0.39-3.08 v-10.48h-15.96v-13.02h28.98v26.34c0,3.72-1.34,6.92-4.01,9.6c-2.68,2.68-5.91,4.01-9.69,4.01H1248.59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1333.78,1035.3v-70.4h56.79c3.78,0,7.02,1.36,9.69,4.06c2.68,2.71,4.01,5.89,4.01,9.55v19 c0,3.72-1.34,6.92-4.01,9.6c-2.68,2.68-5.91,4.01-9.69,4.01h-3.82l17.43,20.56v3.62h-14.1l-20.27-24.18l-23.11,0.1v24.09H1333.78z  M1350.13,998.09h37.7c1.76,0,2.76-0.1,2.99-0.29c0.23-0.2,0.34-1.21,0.34-3.04v-13.51c0-1.83-0.11-2.86-0.34-3.08 c-0.23-0.23-1.22-0.34-2.99-0.34h-37.7c-1.83,0-2.86,0.11-3.08,0.34c-0.23,0.23-0.34,1.26-0.34,3.08v13.51 c0,1.83,0.11,2.84,0.34,3.04C1347.27,997.99,1348.3,998.09,1350.13,998.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1445.69,1035.3c-3.72,0-6.92-1.34-9.6-4.01c-2.68-2.68-4.01-5.87-4.01-9.6v-43.28c0-3.72,1.34-6.92,4.01-9.6 c2.68-2.68,5.87-4.01,9.6-4.01h43.28c3.72,0,6.92,1.34,9.6,4.01c2.68,2.68,4.01,5.87,4.01,9.6v43.28c0,3.72-1.34,6.92-4.01,9.6 c-2.68,2.68-5.87,4.01-9.6,4.01H1445.69z M1448.44,1022.28h37.7c1.76,0,2.77-0.11,3.04-0.34c0.26-0.23,0.39-1.26,0.39-3.08v-37.6 c0-1.83-0.13-2.86-0.39-3.08c-0.26-0.23-1.27-0.34-3.04-0.34h-37.7c-1.83,0-2.86,0.11-3.09,0.34c-0.23,0.23-0.34,1.26-0.34,3.08 v37.6c0,1.83,0.11,2.86,0.34,3.08C1445.58,1022.16,1446.61,1022.28,1448.44,1022.28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1544.39,1035.3c-3.72,0-6.92-1.34-9.6-4.01c-2.68-2.68-4.01-5.87-4.01-9.6V964.8h12.93v54.05 c0,1.83,0.11,2.86,0.34,3.08c0.23,0.23,1.26,0.34,3.09,0.34h37.7c1.76,0,2.77-0.11,3.04-0.34c0.26-0.23,0.39-1.26,0.39-3.08V964.8 h13.02v56.89c0,3.72-1.34,6.92-4.01,9.6c-2.68,2.68-5.87,4.01-9.6,4.01H1544.39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1629.68,1035.3v-70.4h56.79c3.78,0,7.02,1.36,9.69,4.06c2.68,2.71,4.01,5.89,4.01,9.55v19 c0,3.72-1.34,6.92-4.01,9.6c-2.68,2.68-5.91,4.01-9.69,4.01l-43.87,0.1v24.09H1629.68z M1646.03,998.09h37.7 c1.76,0,2.77-0.1,3.04-0.29c0.26-0.2,0.39-1.21,0.39-3.04v-13.51c0-1.83-0.13-2.86-0.39-3.08c-0.26-0.23-1.27-0.34-3.04-0.34 h-37.7c-1.83,0-2.86,0.11-3.09,0.34c-0.23,0.23-0.34,1.26-0.34,3.08v13.51c0,1.83,0.11,2.84,0.34,3.04 C1643.17,997.99,1644.2,998.09,1646.03,998.09z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 370.1422,
    y1: 927.4412,
    x2: 424.7031,
    y2: 1073.4966
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1AE5DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6278EE"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M442.42,1022.73h-36.68v36.67c-20.25,0-36.68-16.41-36.68-36.67s16.42-36.68,36.68-36.68 S442.42,1002.48,442.42,1022.73z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 341.03,
    y1: 938.3163,
    x2: 395.591,
    y2: 1084.3718
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1AE5DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6278EE"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M309.57,1022.73h-9.74c0-58.4,47.51-105.91,105.91-105.91v9.74C352.71,926.56,309.57,969.7,309.57,1022.73z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 347.2777,
    y1: 935.9825,
    x2: 401.8386,
    y2: 1082.038
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1AE5DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6278EE"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M332.3,1022.73h-9.74c0-45.87,37.32-83.18,83.18-83.18v9.74C365.24,949.29,332.3,982.23,332.3,1022.73z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 351.7335,
    y1: 934.318,
    x2: 406.2944,
    y2: 1080.3734
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1AE5DA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6278EE"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M405.74,1083.18c-33.33,0-60.45-27.12-60.45-60.45c0-33.33,27.12-60.45,60.45-60.45v9.74 c-27.96,0-50.71,22.75-50.71,50.71s22.75,50.71,50.71,50.71V1083.18z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLight);
export default __webpack_public_path__ + "static/media/logo-light.9a103ed683190483ad733370db694aee.svg";
export { ForwardRef as ReactComponent };